import {Injectable} from '@angular/core';
import {PaginatedResponse, ServiceProviderHub} from '@generated-backend-types';
import Event = ServiceProviderHub.App.Http.Resources.ServiceProviderHub.Events.Event;
import EventmanagementEvent = ServiceProviderHub.App.Http.Resources.ServiceProviderHub.Eventmanagement.Event.Event;
import TableConfig = ServiceProviderHub.App.Http.Resources.ServiceProviderHub.Meta.TableConfig;
import PrivateAttachmentTypeEnum = ServiceProviderHub.App.Enums.Administrations.Attachments.PrivateAttachmentTypeEnum;
import EventStateEnum = ServiceProviderHub.App.Enums.Eventmanagement.Events.EventStateEnum;
import Room = ServiceProviderHub.App.Http.Resources.ServiceProviderHub.Resources.Rooms.Room;
import ServiceProviderInquiry = ServiceProviderHub.App.Http.Resources.ServiceProviderHub.Eventmanagement.Event.Inquiry.EventInquiry;
import ServiceProviderTypeEnum = ServiceProviderHub.App.Enums.Resources.ServiceProviderTypeEnum;
import CountryCodeISOAlpha3Enum = ServiceProviderHub.App.Enums.CountryCodeISOAlpha3Enum;
import ServiceProviderInquiryStateEnum = ServiceProviderHub.App.Enums.Eventmanagement.Events.ServiceProviderInquiry.ServiceProviderInquiryStateEnum;
import TableConfigColumnTypeEnum = ServiceProviderHub.App.Enums.TableConfigColumnTypeEnum;
import RoomPrimaryCategoryEnum = ServiceProviderHub.App.Enums.Resources.RoomPrimaryCategoryEnum;

@Injectable({providedIn: 'root'})
export class MockService {
  private static eventId: string = '';
  readonly tableConfig: TableConfig[] = [
    {
      id: 'service-provider-hub.events.index',
      url: '/api/events',
      columns: [
        {
          name: 'id',
          type: TableConfigColumnTypeEnum.STRING,
          filterable: true,
          quick_filter: true,
          required_filter: false,
          default_filter: null,
          sortable: true,
          initially_hidden: false,
          visible: true,
          filter_visible: true,
          show_column_header: true,
          meta: {
            property_for_url: null,
            property_for_label: null,
            function: null,
          }
        },
        {
          name: 'event_title',
          type: TableConfigColumnTypeEnum.STRING,
          filterable: true,
          quick_filter: true,
          required_filter: false,
          default_filter: null,
          sortable: true,
          initially_hidden: false,
          visible: true,
          filter_visible: true,
          show_column_header: true,
          meta: {
            property_for_url: null,
            property_for_label: null,
            function: null,
          }
        },
        {
          name: 'event_start',
          type: TableConfigColumnTypeEnum.DATE,
          filterable: true,
          quick_filter: false,
          required_filter: false,
          default_filter: null,
          sortable: true,
          initially_hidden: false,
          visible: true,
          filter_visible: true,
          show_column_header: true,
          meta: {
            property_for_url: null,
            property_for_label: null,
            function: null,
          }
        },
        {
          name: 'event_end',
          type: TableConfigColumnTypeEnum.DATE,
          filterable: true,
          quick_filter: false,
          required_filter: false,
          default_filter: null,
          sortable: true,
          initially_hidden: false,
          visible: true,
          filter_visible: true,
          show_column_header: true,
          meta: {
            property_for_url: null,
            property_for_label: null,
            function: null,
          }
        },
        {
          name: 'event_state',
          type: TableConfigColumnTypeEnum.STRING,
          filterable: true,
          quick_filter: false,
          required_filter: false,
          default_filter: null,
          sortable: true,
          initially_hidden: false,
          visible: true,
          filter_visible: true,
          show_column_header: true,
          meta: {
            property_for_url: null,
            property_for_label: null,
            function: null,
          }
        },
        {
          name: 'event_operations_manager',
          type: TableConfigColumnTypeEnum.STRING,
          filterable: true,
          quick_filter: false,
          required_filter: false,
          default_filter: null,
          sortable: true,
          initially_hidden: false,
          visible: true,
          filter_visible: true,
          show_column_header: true,
          meta: {
            property_for_url: null,
            property_for_label: null,
            function: null,
          }
        },
        {
          name: 'event_project_manager',
          type: TableConfigColumnTypeEnum.STRING,
          filterable: true,
          quick_filter: false,
          required_filter: false,
          default_filter: null,
          sortable: true,
          initially_hidden: false,
          visible: true,
          filter_visible: true,
          show_column_header: true,
          meta: {
            property_for_url: null,
            property_for_label: null,
            function: null,
          }
        }
      ],
      permissions: {
        create: 'resources_serviceprovider_serviceprovider.create.*',
        update: 'resources_serviceprovider_serviceprovider.update.*',
        delete: 'resources_serviceprovider_serviceprovider.delete.*',
        read: 'resources_serviceprovider_serviceprovider.read.*',
      },
      filter_type: ServiceProviderHub.App.Enums.TableFilterDisplayTypeEnum.MULTI_COLUMN_FILTER,
    }
  ];
  private readonly inquiryIDs = ['a5bdde8b-0073-33eb-8b9b-934992b7270b', '1431a578-f17c-3192-b459-fb0dd1487a45', 'd6253c66-42a9-30b5-bfdf-27059b6175a9'];
  private inquiries: ServiceProviderInquiry[] = [...Array(3).keys()].map(index => {
    const event: Event = {
      id: MockService.eventId,
      title: `Veranstaltung ${index + 1}`,
      state: EventStateEnum.RESERVED,
      setup_phase_start_at: (new Date()).toISOString(),
      teardown_phase_end_at: (new Date()).toISOString(),
      start_at: (new Date()).toISOString(),
      end_at: (new Date()).toISOString(),
      project_manager_one: {
        id: '123',
        first_name: 'PM',
        last_name: 'One',
        phone_number: '123456789',
        email: 'pm@local.test',
        created_at: (new Date()).toISOString(),
        updated_at: (new Date()).toISOString(),
      },
      operations_manager_one: {
        id: '456',
        first_name: 'OM',
        last_name: 'One',
        phone_number: '123456789',
        email: 'om@local.test',
        created_at: (new Date()).toISOString(),
        updated_at: (new Date()).toISOString(),
      },
      latest_version_id: '',
      ext_event_id: '',
      revenue_cost_center: ServiceProviderHub.App.Enums.Eventmanagement.Events.EventRevenueCostCenterEnum.BMW_WELT,
      project_manager_one_id: null,
      operations_manager_one_id: null,
      security_instructions: [],
      seating_layouts: [],
      meta: {
        private_attachments: {
          file_limits: []
        }
      },
      created_at: '',
      updated_at: '',
    };

    const room: Room = {
      primary_category: RoomPrimaryCategoryEnum.UTILIZATION_FEE,
      id: '1',
      latest_version_id: '',
      internal_title: 'Test Raum (intern)',
      title: {
        de: 'Test Raum',
        en: 'Test Room'
      },
      location_id: '123'
    }

    return {
      id: this.inquiryIDs[index],
      event_id: MockService.eventId,
      primary: index === 0,
      ext_inquiry_id: this.inquiryIDs[index],
      received_on: (new Date()).toISOString(),
      submission_deadline: (new Date()).toISOString(),
      state: ServiceProviderInquiryStateEnum.REMINDED_INQUIRY,
      service_provider_id: '',
      service_provider: {
        id: '1',
        company: 'Company',
        contact: 'Ansprechpartner',
        street: '',
        street_number: '',
        zip_code: '',
        city: '',
        country: CountryCodeISOAlpha3Enum.DEU,
        website: '',
        type: ServiceProviderTypeEnum.EXTERNAL,
        created_at: (new Date()).toISOString(),
        updated_at: (new Date()).toISOString()
      },
      event: event,
      event_title: event.title,
      event_start: event.start_at,
      event_end: event.end_at,
      event_state: event.state,
      event_project_manager: event.project_manager_one?.first_name ?? '',
      event_operations_manager: event.operations_manager_one?.first_name ?? '',
      event_overview_snapshot_id: null,
      positions: [
        {
          id: '1',
          start: (new Date()).toISOString(),
          end: (new Date()).toISOString(),
          amount: 1,
          type: 'Dienstleistung',
          ressource: 'Bestuhlung',
          room,
          notes_from_service_provider: '',
          notes_to_service_provider: 'Wir benötigen ein Angebot für die Bestuhlung im Auditorium für 362 Personen in parlamentarischer Bestuhlung.',
          price: '',
          price_correction: '',
          price_correction_reason: '',
        },
        {
          id: '2',
          start: (new Date()).toISOString(),
          end: (new Date()).toISOString(),
          amount: 1,
          type: 'Dienstleistung',
          ressource: 'Streaming',
          room,
          notes_from_service_provider: '',
          notes_to_service_provider: 'Wir benötigen ein Streaming-Angebot im Raum Auditorium für 3 Stunden.',
          price: '',
          price_correction: '',
          price_correction_reason: '',
        }
      ],
      total_net: 0,
      total_after_price_correction: 0,
      pro_forma_invoice_requested_on: (new Date()).toISOString(),
      final_invoice_requested_on: (new Date()).toISOString(),
      final_invoice_sent_on: (new Date()).toISOString(),
      offer_sent_on: (new Date()).toISOString(),
      pro_forma_invoice_sent_on: (new Date()).toISOString(),
      meta: {
        private_attachments: {
          file_limits: [
            {
              attachment_type: PrivateAttachmentTypeEnum.RESOURCES_SERVICE_PROVIDER_INQUIRIES_OFFER,
              max_files: 1,
              new_uploads_allowed: true,
            },
            {
              attachment_type: PrivateAttachmentTypeEnum.RESOURCES_SERVICE_PROVIDER_INQUIRIES_PRO_FORMA_INVOICE,
              max_files: 1,
              new_uploads_allowed: true,
            },
            {
              attachment_type: PrivateAttachmentTypeEnum.RESOURCES_SERVICE_PROVIDER_INQUIRIES_FINAL_INVOICE,
              max_files: 1,
              new_uploads_allowed: true,
            },
            {
              attachment_type: PrivateAttachmentTypeEnum.RESOURCE_ROOM_FLOOR_PLAN,
              max_files: 1,
              new_uploads_allowed: true,
            },
            {
              attachment_type: PrivateAttachmentTypeEnum.EVENTMANAGEMENT_EVENT_SECURITY_INSTRUCTIONS,
              max_files: 1,
              new_uploads_allowed: true,
            }
          ]
        }
      },
      created_at: (new Date()).toISOString(),
      updated_at: (new Date()).toISOString(),
      state_changes: {
        inquiry_requested_at: null,
        offer_received_at: null,
        offer_confirmed_at: null,
        reminder_sent_at: null,
        pro_forma_invoice_requested_at: null,
        pro_forma_invoice_received_at: null,
        final_invoice_requested_at: null,
        final_invoice_received_at: null,
        inquiry_cancelled_at: null,
        inquiry_declined_at: null
      },
      actions: {
        send_offer: false,
        no_inquiry: false,
        send_proforma_invoice: false,
        send_final_invoice: false,
        allow_variant_changes: false,
        allow_price_correction_requests: false
      }
    } as unknown as ServiceProviderInquiry;
  });

  private events: EventmanagementEvent[] = [
    {
      id: MockService.eventId,
      ext_event_id: 'EVT-0001',
      title: 'Mock Veranstaltung',
      state: EventStateEnum.RESERVED,
      start_at: (new Date()).toISOString(),
      end_at: (new Date(Date.now() + 86_400_000)).toISOString(),
      setup_phase_start_at: null,
      teardown_phase_end_at: null,
      main_event_type: null,
      event_format: null,
      event_characteristics: [],
      with_vips: false,
      max_participants: null,
      cancelled_at: null,
      revenue_cost_center: ServiceProviderHub.App.Enums.Eventmanagement.Events.EventRevenueCostCenterEnum.BMW_WELT,
      project_manager_one_id: null,
      operations_manager_one_id: null,
      organizer_company: 'Mock Veranstalter GmbH',
      seating_layouts: [],
      security_instructions: [],
      sph_files: [],
      meta: {
        private_attachments: {
          file_limits: [],
        },
      },
      created_at: (new Date()).toISOString(),
      updated_at: (new Date()).toISOString(),
    },
  ];

  static setEventId(id: string) {
    this.eventId = id;
    // Keep the in-memory mocks aligned with the active event id so resolvers
    // for /events/:id and /events/:id/inquiries/:inquiryId return matching data.
  }

  getAllEvents = (): EventmanagementEvent[] => this.events.map(e => ({...e, id: MockService.eventId}));
  getEvent = (id: string): EventmanagementEvent | undefined =>
    this.getAllEvents().find(e => e.id === id);
  getAllInquiries = () => this.inquiries.map(i => ({...i, event_id: MockService.eventId}));
  getInquiry = (id: string) => this.getAllInquiries().find(i => i.id === id);

  paginate<T>(items: T[], page: number, path: string, perPage = 30): PaginatedResponse<T> {
    const total = items.length;
    const from = (page - 1) * perPage;
    const to = page * perPage;

    return {
      data: items.slice(from, to),
      meta: {current_page: page, from, last_page: Math.floor(total / perPage), path, per_page: perPage, to, total},
    };
  }
}
